import React from "react";
import { tracker } from "library/tracker";
import PrimeTransactionContainer from "containers/jarivsPrime/PrimeTransaction";

const PrimeTransaction = () => {
  React.useEffect(() => {
    tracker.pageView();
  }, []);

  return <PrimeTransactionContainer />;
};

export default PrimeTransaction;
